import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import Paper from '@mui/material/Paper';

const MainBox = ({
  sx = {},
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Paper, _extends({
    sx: {
      mb: 2,
      p: {
        xs: 0,
        sm: 2
      },
      ...sx
    }
  }, props), children);
};

export { MainBox, MainBox as default };
